<template>
  <div class="hello">
    <header>
      <h1>Sweet定位-VIP服务协议</h1>
      <p>最近更新日期：2025年10月29日</p>
    </header>
    <section>
      <h2>重要提示</h2>
      <p>《Sweet定位-VIP服务协议》（以下简称“本协议”）是您与重庆盛纳科技有限公司（以下简称“我们”或“公司”）之间关于“Sweet定位 VIP”服务的协议，是《Sweet定位-用户协议》的组成部分。本协议未涉及事项以《Sweet定位-用户协议》为准。若您不同意本协议，不影响您依据《Sweet定位-用户协议》享有的基本权利与义务。公司会不定时发布VIP服务相关规范、规则为本协议补充，公示后生效。请您在使用本服务前仔细阅读并确认接受本协议。若您是未成年人，须在监护人陪同下阅读本协议，经监护人同意后方可使用。</p>
      <p>您须注册Sweet定位账号或登录已有账号后才能购买VIP服务。支付费用后，您将成为“Sweet定位 VIP”并有权使用相关VIP服务。购买前请确认接受以下条款。</p>
      <h2>一、协议条款的接受与修订</h2>
      <p>1.1 您对本协议的查看、使用等任何行为，以及购买VIP行为，均视为已阅读并同意本协议及更新后的内容。</p>
      <p>1.2 公司可根据国家政策、服务调整等情况修订本协议，更新后您继续使用服务即视为接受修订后的协议。</p>
      <p>1.3 未成年人应在监护人陪同下审阅协议，其使用服务的行为视为已获监护人认可。</p>
      <h2>二、VIP服务及功能说明</h2>
      <p>2.1 VIP专享服务：在服务有效期内，您可享受查看30天足迹详情、对方的每日报告、出行自动报备、动态提醒、恢复近90天聊天记录等VIP专享功能。</p>
      <p>2.2 服务范围限制：VIP服务仅限在Sweet定位应用内使用，任何以破解、编译、转录等非法手段将公司提供的服务内容与Sweet定位应用分离的行为，公司将依法追究行为人的法律责任，由此引起的一切法律后果将由行为人负责。如您的行为违反有关法律、法规或本协议的约定，公司有权要求您停止行为并依法追究您的责任，此外，公司有权单方终止本服务并要求您赔偿经济损失。</p>
      <p>2.3 定位服务说明：公司尽力保障定位准确性，但服务可能受网络环境、设备性能、地理位置等因素影响，实际效果以使用时为准。您理解并同意，定位信息的采集与使用将严格遵循《Sweet定位-隐私政策》。</p>
      <h2>三、VIP权利与限制</h2>
      <p>3.1 VIP权利：在VIP服务有效期内，您可以在同等条件下优先参加由公司组织的活动，并享有由公司提供的各项优惠及增值服务。</p>
      <p>3.2 使用规范：</p>
      <ul>
        <li>(1)需登录Sweet定位账号并联网确认VIP身份，否则无法使用VIP权益；</li>
        <li>(2)VIP身份不可转让，其服务仅限您与情侣双方私人使用，不得用于商业、盈利等用途；</li>
        <li>(3)不得转让VIP服务；</li>
        <li>(4)定位信息仅限您与情侣双方查看使用，不得用于侵犯他人隐私、危害安全等非法活动。</li>
      </ul>
      <p>3.3 禁止行为：</p>
      <ul>
        <li>(1)以非法方式或目的使用Sweet定位 VIP服务（如伪造定位、追踪他人）；</li>
        <li>(2)有偿或无偿向第三方提供账号信息，并允许他通过您的账号使用非他购买的VIP服务。若发生前述情形，公司将有权对该违规账号采取临时/永久措施以限制该账号的继续使用；</li>
        <li>(3)复制、销售、出租或授权第三方使用VIP服务内容；</li>
        <li>(4)破解、篡改 APP 安全措施或协助他人实施此类行为；</li>
        <li>(5)通过非官方渠道获取VIP服务及相关权益，或删除服务相关的所有权声明或者标识。</li>
      </ul>
      <h2>四、收费与退费管理</h2>
      <p>4.1 开通方式：通过Sweet定位账号购买，支付成功后即开通VIP服务，价格以开通时显示金额为准，可能因服务周期、活动等因素存在差异。</p>
      <p>4.2 费用性质：VIP服务并非存款、预付款或其他可无理由退还性质的商品或财产权利，VIP服务提供的商品根据《消费者权益保护法》属于在线拆封交付的数字化商品，因其特殊属性不适用《消费者权益保护法》中有关反悔权及网络购买商品七日无理由退货等条款的约束，VIP购买成功，商品即完成在线交付，一经购买，本平台不提供任何退还服务。除法律法规明确要求以外或因产品技术原因，导致您购买时被重复扣款或无法享有购买的服务时，您可提出退款申请。提出退款申请时，需要您提供相应信息，经我们核实后方可为您办理退款。您理解并清楚接受上述条件，如您不接受，请谨慎选择此服务。
  </p>
  <p>在购买VIP服务时，用户必须仔细确认自己的账号及需要购买的VIP类型，若因用户自身操作不当或不了解服务计费方式等因素造成充错账号、错选服务类型等情形而损害自身权益的，不得因此要求我们作任何补偿或赔偿。</p>
      <p>4.3 自动续费：如开通自动续费，服务期满后将按约定从绑定账户扣取下一周期的费用，您可随时取消自动续费，扣款成功后不予退款。</p>
      <h2>五、账号与信息安全</h2>
      <p>5.1 账号管理：您应妥善保管账号、密码及相关信息，因您自己保管不当导致的账号被盗、信息泄露等损失，公司不承担责任。</p>
      <p>5.2 身份验证：公司可定期或不定期对账号安全进行检查、验证，您拒绝配合或无法完成验证的，公司可采取暂停服务等措施保护账号安全。</p>
      <p>5.3 安全限制：VIP服务仅限个人使用，禁止转借、租赁账号，公司可通过限制同时登录设备数量等方式防范账号异常使用。</p>
      <h2>六、权利声明</h2>
      <p>6.1 您拥有合法获得的Sweet定位 VIP服务及内容的使用权，VIP服务、功能和衍生物的所有权及知识产权均归公司或原权利人所有。</p>
      <p>6.2 未经公司书面许可，任何人不得复制、下载、修改、传播VIP服务内容，或利用其创作衍生品。</p>
      <h2>七、服务的中止、终止及变更</h2>
      <p>7.1 本服务的中止或终止情形包含：</p>
      <ul>
        <li>(1)您主动中止（如VIP到期未续费）；</li>
        <li>(2)因您违约，公司主动中止或终止；</li>
        <li>(3)应国家监管要求或不可抗力因素导致服务中止、终止；</li>
        <li>(4)其他依法应中止、终止服务的情况。</li>
      </ul>
      <p>7.2 您确认并同意：</p>
      <ul>
        <li>(1)除法律规定外，公司不因服务中止或终止对您和第三方承担任何责任；</li>
        <li>(2)已收取费用除法律规定或本协议另有约定外，不予退还；</li>
        <li>(3)公司将删除VIP相关数据，无返还或以任何形式恢复数据的义务。</li>
      </ul>
      <p>7.3 不可抗力因素：因政策调整、自然灾害等不可抗力因素，导致VIP服务无法继续的，公司会及时通知用户，但不承担由此对用户造成的任何损失且不退还费用。在某些罕见不可抗力情形下，由于权利授权问题可能致使Sweet定位上某些VIP内容无法下载使用。在这种情况下，公司不承担由此对用户造成的任何损失且不退还费用。</p>
      <h2>八、免责声明</h2>
      <p>8.1 非公司可控原因导致VIP在使用服务中遭受的人身、财务损失，公司不承担责任。</p>
      <p>8.2 因第三方通讯故障、网络问题、电脑故障、系统不稳定及不可抗力因素等原因造成的损失，公司不负责且无法补偿。</p>
      <p>8.3 服务期限包含服务器维修、调整、升级及处理黑客攻击、病毒侵入等故障的合理时间，公司对此类时间造成的影响不做补偿。</p>
      <h2>九、补充说明</h2>
      <p>9.1 本协议任一条款无效或不可执行，不影响其余条款的有效性及可执行性。</p>
      <p>9.2 公司有权根据业务调整变更服务主体，变更不影响您的权益。</p>
      <p>9.3 公司未及时行使权利不视为放弃，不影响将来行使该权利。</p>
      <p>9.4 本协议适用中华人民共和国法律，若VIP和Sweet定位之间发生任何纠纷或争议，应先尽量友好协商解决。协商不成时，VIP同意将纠纷或争议提交Sweet定位住所地有管辖权的人民法院管辖。</p>
      <p>9.5 如有疑问，请通过邮件<b>sweet_9966@126.com</b>与我们进行沟通。</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px
}
.hello{
  margin:20px;
}
section{
  padding-bottom:20px;
}
h1 {
  font-size: 18px;
  margin: 10px 0;
}

h2 {
  margin: 10px 0;
  font-size: 14px
}


li {
  margin: 10px 0;
  list-style: none;
}


p {
  margin: 10px 0;
}

.tab {
  table-layout: fixed;
  text-align: left;
  width: 100%;
  border-collapse: collapse;
}

.tab tr {
  width: 100%;
}

.tab th {
  padding: 0 4px;
}

.tab td {
  width: 25%;
  padding: 0 4px;
  word-break: break-all;
}

.link {
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue